import { render, staticRenderFns } from "./MainLedgerDetailListVertical.vue?vue&type=template&id=6192afda"
import script from "./MainLedgerDetailListVertical.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailListVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports